// Determines how the front-end calls the API back-end.
//
// Individual */api.js proxy functions in respective packages
// are configured to know their relative paths, e.g. /api/observations/875d209857f
//
// By default, for server deployments we assume that the
// API back-end and the Web front-end are served by the same
// host. For running on localhost, we assume that this React app
// is being served by its own hot-reloading devserver, and that
// the back-end is running by the independently-started Synapse
// API server running on the developer-default port.
export const API_BASE_URL =
  typeof window != "undefined"
    ? window.location.hostname == "localhost"
      ? // When running locally, assume local synapse back-end started independently
        "http://localhost:8081"
      : // Otherwise, assume back-end is served by same server
        `${window.location.protocol}//${window.location.hostname}`
    : null
